import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import moment from "Helpers/MomentCompat";
import { showNotification } from "Helpers/Toast";

import UseAuth from "Hooks/UseAuth";
import UseFile from "Hooks/UseFile";
import UseServices from "Hooks/UseServices";

import Button from "Components/Global/Buttons";
import Input from "Components/Global/Form/Input";

import * as S from "../Schedule/styles";

// Sessão PASTA DE RELATÓRIOS (A12/A13 — D8/D26): o PROPONENTE cadastra e
// edita (a edição devolve o relatório a Pendente — é assim que o Reprovado
// reabre a avaliação do admin); o patrocinador Aportado só lê os Aprovados
// (recorte no backend).
const Reports = ({ projectId }) => {
  const { api } = UseServices();
  const { parsedJWT } = UseAuth();
  const { uploadFile } = UseFile();

  const [reports, setReports] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const is_sponsor = parsedJWT?.user?.is_sponsor;

  const getReports = () => {
    api
      .post("/project-reports/list", { project_id: projectId })
      .then((response) => setReports(response.data?.reports || []))
      .catch((error) => HTTPErrorCallback(error));
  };

  useEffect(() => {
    if (projectId) getReports();
    // eslint-disable-next-line
  }, [projectId]);

  const openCreate = () => {
    setEditing(null);
    setName("");
    setDescription("");
    setFile(null);
    setShowForm(true);
  };

  const openEdit = (report) => {
    setEditing(report);
    setName(report.name);
    setDescription(report.description || "");
    setFile(null);
    setShowForm(true);
  };

  const saveReport = async () => {
    setSaving(true);

    try {
      const file_src = file ? await uploadFile(file) : undefined;

      if (editing) {
        await api.post("/project-reports/update", {
          report_id: editing.id,
          name,
          description,
          // Sem arquivo novo, a chave não viaja e o backend mantém o atual.
          ...(file_src ? { file_src } : {}),
        });
      } else {
        await api.post("/project-reports/create", {
          project_id: projectId,
          name,
          description,
          file_src,
        });
      }

      showNotification("success", "Sucesso!", "Relatório salvo com sucesso!");

      setShowForm(false);
      setEditing(null);
      getReports();
    } catch (error) {
      HTTPErrorCallback(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <S.Wrapper>
      <S.Section>
        <span>Pasta de relatórios</span>
        <hr />
      </S.Section>

      {!is_sponsor ? (
        <S.Buttons>
          <Button
            type="button"
            text={showForm ? "Fechar" : "Criar Relatório"}
            outline={showForm}
            onClick={() => (showForm ? setShowForm(false) : openCreate())}
          />
        </S.Buttons>
      ) : null}

      {showForm && !is_sponsor ? (
        <S.FormBlock>
          <Form autoComplete="off">
            <Input
              name="report_name"
              label="Nome"
              placeholder="Nome do relatório"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <Input
              name="report_description"
              label="Descrição"
              placeholder="Descrição"
              type="textarea"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <input
              aria-label="Arquivo do relatório"
              type="file"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
            />
            <Button
              type="button"
              text={editing ? "Salvar Alterações" : "Salvar Relatório"}
              disabled={saving || !name || (!editing && !file)}
              onClick={saveReport}
            />
          </Form>
        </S.FormBlock>
      ) : null}

      {!reports.length ? <span>Nenhum relatório disponível.</span> : null}

      {reports.map((report) => (
        <S.Event key={report.id}>
          <h2>{report.name}</h2>
          {report.description ? <span>{report.description}</span> : null}
          <span>
            Enviado em {moment(report.created_at).format("DD/MM/YYYY")}
            {!is_sponsor ? ` · ${report.status}` : ""}
          </span>
          <a href={report.file_src} target="_blank" rel="noreferrer">
            Abrir arquivo
          </a>

          {!is_sponsor ? (
            <S.Buttons>
              <Button
                type="button"
                outline
                text="Editar"
                onClick={() => openEdit(report)}
              />
            </S.Buttons>
          ) : null}
        </S.Event>
      ))}
    </S.Wrapper>
  );
};

export default Reports;
